var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineChartImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8014 2.83705C17.5353 2.57025 17.1041 2.56955 16.8371 2.83523L11.6601 7.99134L10.1639 6.4952C9.89755 6.22907 9.46622 6.22882 9.19984 6.4952L3.13167 12.5634C2.86529 12.8295 2.86529 13.2614 3.13167 13.5275C3.26463 13.6607 3.43918 13.7273 3.61373 13.7273C3.78803 13.7273 3.96283 13.6607 4.09576 13.5275L9.6819 7.94159L11.1771 9.43658C11.4433 9.70271 11.8735 9.70296 12.1403 9.4377L17.7994 3.80135C18.0662 3.53568 18.0671 3.10385 17.8014 2.83705Z",
    fill: "#0E0063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2954 15.8182H1.36364V1.5C1.36364 1.1234 1.05841 0.818176 0.681819 0.818176C0.305226 0.818176 0 1.1234 0 1.5V16.5C0 16.8766 0.305226 17.1818 0.681819 17.1818H17.2954C17.672 17.1818 17.9773 16.8766 17.9773 16.5C17.9773 16.1234 17.672 15.8182 17.2954 15.8182Z",
    fill: "#0E0063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3181 2.61365H12.2045C11.8279 2.61365 11.5227 2.91887 11.5227 3.29547C11.5227 3.67206 11.8279 3.97729 12.2045 3.97729H16.6363V8.40932C16.6363 8.78567 16.9416 9.09114 17.3182 9.09114C17.6948 9.09114 17.9999 8.78567 17.9999 8.40908V3.29547C17.9999 2.91887 17.6947 2.61365 17.3181 2.61365Z",
    fill: "#0E0063"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartImg);
export default __webpack_public_path__ + "static/media/line_chart_img.82ce2760.svg";
export { ForwardRef as ReactComponent };